import styled from 'styled-components';
import Image from 'next/image';
import { fontSettings } from '../../../../../styles';

export const Activate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 32px;
`;
export const ActivateTitle = styled.div`
  ${(props): string =>
    fontSettings(props.theme.FONT.SIZE_28, props.theme.FONT)};
  color: ${({ theme }): string => theme.COLOR.TEXT_DARK_COLOR};
  font-weight: 700;
`;

export const ActivateSticker = styled.div`
  background: #dbff73;
  padding: 4px 8px;
  margin-bottom: -16px;
  width: max-content;
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  font-weight: 700;
  color: ${({ theme }): string => theme.COLOR.TEXT_DARK_COLOR};
  ${({ theme }): string => fontSettings(theme.FONT.SIZE_13, theme.FONT)};
`;

export const ActivateLogo = styled(Image)``;
